import type { ComponentType, LazyExoticComponent } from 'react';
import { lazyWithRetry } from './helpers';

/**
 * Master switch for the entire prototype layer (corner ribbon, dashed border,
 * `<Prototype>` wrapper, `enabledPrototypeRoutes()` gating). Set per-environment
 * in `apps/web/.env.*` (`development`, `local-api`, `production`) — defaults to
 * `false` when missing so production builds without the var stay safe.
 */
const prototypesEnabled = import.meta.env.VITE_PROTOTYPES_ENABLED === 'true';

export const features = {
  prototypesEnabled,
  predicate: import.meta.env.VITE_FEATURE_PREDICATE === 'true',
  // Production flag (not a prototype): the redesigned patient "My Research" page.
  myResearchV2: import.meta.env.VITE_FEATURE_MY_RESEARCH_V2 === 'true',
} as const;

export type FeatureName = keyof typeof features;

export const lazyFeature = <T extends ComponentType<any>>(
  loader: () => Promise<{ default: T }>,
  displayName: string,
): LazyExoticComponent<T> => lazyWithRetry(loader, displayName);
